import React from "react";
import classnames from "classnames";

const Button = ({
  children,
  buttonColor,
  buttonTextColor,
  shadow,
  style,
  disabled,
  className,
  buttonContainerClassName,
  paddingHorizontal,
  paddingVertical,
  onClick,
  green,
  purple,
  overrideStyle
}) => {
  const newClassName = classnames(className, {
    "cursor-pointer": !disabled,
    "cursor-default": disabled,
    "btn-green": green,
    "bg-boost-primary-purple hover:bg-purple-700": purple,
    btn: !overrideStyle,
  });
  return (
    <div className={buttonContainerClassName}>
      <button
        data-testid="Button-testSelector"
        type="button"
        className={newClassName}
        onClick={disabled ? () => {} : onClick}
        disabled={disabled}
        style={{
          ...style,
          backgroundColor: buttonColor,
          color: buttonTextColor,
          boxShadow: shadow,
          paddingLeft: paddingHorizontal,
          paddingRight: paddingHorizontal,
          paddingTop: paddingVertical,
          paddingBottom: paddingVertical
        }}
      >
        {children}
      </button>
    </div>
  );
};

Button.defaultProps = {
  className: "",
  buttonColor: "",
  buttonTextColor: "",
  shadow: "",
  disabled: false,
  paddingHorizontal: 16,
  paddingVertical: 8,
  style: {},
  onClick: () => {}
};

export default Button;
